import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e4f3e1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid d-flex justify-content-center align-items-center py-5" }
const _hoisted_2 = { class: "container rounded-4 p-3 shadow" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 p-5" }
const _hoisted_5 = { class: "fw-bold text-white mb-3 mb-lg-5" }
const _hoisted_6 = { class: "fw-bold text-white mb-3 mb-lg-5" }
const _hoisted_7 = { class: "fw-bold text-white mb-3 mb-lg-5 alumnus2" }
const _hoisted_8 = { class: "col-lg-6 gx-0 gx-lg-3" }
const _hoisted_9 = { class: "bg-white rounded-4 shadow p-3 p-lg-5" }
const _hoisted_10 = { class: "text-center fs-7 w-100 mb-3 sns-integration-note" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "sns-integration-note-br" }, null, -1))

import LoginForm from './components/LoginForm.vue'
import { translate } from '@/languages/i18n'
import Login from '@/components/login/index.vue'
import { onMounted } from 'vue'
import SnsLoginButton from '@/components/sns-login-button/index.vue'
import { snsConnectDefinedErrorMsg } from '@/constants/common'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { omit } from 'lodash'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const toast = useToast()

onMounted(() => {
  // 2022/09/23 CW-NamPH7425 Fix for UAT#4480: SA80 (Ph2-R20220930)
  document.body.removeAttribute('style')
  // 2022/09/23 CW-NamPH7425 Fix for UAT#4480: SA80 (Ph2-R20220930)
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  while (modalBackdrop.length > 0) {
    modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
  }

  checkAndHandleConnectError()
})

const checkAndHandleConnectError = () => {
  const { errorCode } = route.query
  if (snsConnectDefinedErrorMsg.includes(errorCode?.toString().toUpperCase() ?? '')) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: errorCode?.toString()?.toUpperCase(),
      },
    })

    router.replace({ ...router.currentRoute, query: omit(route.query, ['errorCode']) })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(translate)('SA80title')), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('SA80alumnus')), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('SA80alumnus2')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Login, {
              title: 'LOGIN',
              color: 'green'
            }, {
              default: _withCtx(() => [
                _createVNode(LoginForm, { class: "login-form" }),
                _createElementVNode("label", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_unref(translate)('SA80snsIntegrationNote1')), 1),
                  _hoisted_11,
                  _createTextVNode(_toDisplayString(_unref(translate)('SA80snsIntegrationNote2')), 1)
                ]),
                _createVNode(SnsLoginButton, {
                  class: "mb-4 align-items-center mx-0",
                  "google-theme": "light",
                  arrangement: "vertical"
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})